import { RowDataBuildConfigEasy } from "../../components/BuildConfigEasyPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the BuildConfigEasyTable factory
 */
class BuildConfigEasyRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/build-config/read-range-easy"
        this.accessData = "builds"
    }

    create(build: any): RowDataBuildConfigEasy {
        const rowDataEasy: RowDataBuildConfigEasy = {
            id: build.id,
            buildId: build.buildId,
            title: build.title,
            images: build.images,
            cpu: build.cpu,
            cooler: build.cooler,
            gpu: build.gpu,
            mobo: build.mobo,
            case: build.case,
            ram: build.ram,
            psu: build.psu,
            ssd1: build.ssd1,
            ssd2: build.ssd2,
            isPrebuild: build.isPrebuild,
            isCustom: build.isCustom,
            isEasy: build.isEasy,
            
            show: build.show,

            action: "",
        };
        return rowDataEasy;
    }
}

let buildConfigEasyRow: BuildConfigEasyRow | null = null;

export default function getBuildConfigEasyRow(): BuildConfigEasyRow {
    if (buildConfigEasyRow === null)
      buildConfigEasyRow = new BuildConfigEasyRow()
    return buildConfigEasyRow
}